import React, { useEffect, useState } from "react";
import { useFormContext, useFieldArray, Controller } from "react-hook-form";
import { Row, Col, Button, Input, FormFeedback } from "reactstrap";
import ViewModal from "../custom-table/ViewModel";
import CustomLabel from "../CustomLabel";
import Select from "react-select";

const FormRepeater = ({ data, route }) => {
  const { control, errors, setValue } = useFormContext();
  const { fields, append, remove } = useFieldArray({
    control,
    name: "formRows",
  });

  const [viewModel, setViewModel] = useState(false);
  const [viewImageUrl, setViewImageUrl] = useState("");

  const [formType, setFormType] = useState({});
  const handleViewImage = (imageUrl) => {
    setViewImageUrl(imageUrl);
    setViewModel(true);
  };
  useEffect(() => {
    if (data && data.length > 0) {
      // Preserve existing fields and their data
      const existingFieldsLength = fields.length;
      
      // Remove all fields
      fields.forEach((_, index) => remove(index));

      data.forEach((item, index) => {
        const { type, sorting, description, image } = item;

        // Append new fields with data from the `data` prop
        append({
          type: type || null,
          sorting: sorting || "",
          description: type === 2 ? description || "" : "", // Set description only if type is 2
          image: type === 1 ? image || null : null // Set image only if type is 1
        });

        // Store the form type for conditional rendering
        setFormType(prev => ({ ...prev, [index]: type || null }));
      });
    }
  }, [data, remove, append]);
  // useEffect(() => {
  //   if (data && data.length > 0) {

  //     fields.forEach((_, index) => remove(index));
  
  //     data.forEach((item, index) => {
  //       const { type, sorting, description, image } = item;
  
  //       setValue(`formRows[${index}].type`, type || null);
  //       setValue(`formRows[${index}].sorting`, sorting || "");
  
  //       if (type === 1) { // Type 1 is Image
  //         console.log("new")
  //         setValue(`formRows[${index}].description`, ""); // Clear description for images
  //         setValue(`formRows[${index}].image`, image|| null); // Set image URL
          
  //       } else if (type === 2) { // Type 2 is Description
  //         console.log("new2")
  //         setValue(`formRows[${index}].description`, description || ""); // Set description
  //         setValue(`formRows[${index}].image`, null); // Clear image for descriptions
  //       }
  
  //       setFormType(prev => ({ ...prev, [index]: type || null }));
  //     });
  //   }
  // }, [data, setValue, remove]);
  


  useEffect(() => {
    if (route === "edit") {
      if (!data || data.length === 0) {
      
        append({
          type: null,
          sorting: "",
          description: "",
          image: null,
        });
      }
    } else {
      if (fields.length === 0) {
        append({
          type: null,
          sorting: "",
          description: "",
          image: null
        });
      }
    }
  }, [data, append, fields.length, route]);

  const handleFileChange = (index, e) => {
    const file = e.target.files[0];

    if (file) {

      setValue(`formRows[${index}].image`, file);
    } else {

      setValue(`formRows[${index}].image`, null); // Clear file if none selected
    }
  };
  
  const handleTypeChange = (index, value) => {
    setValue(`formRows[${index}].type`, value);
  
    if (value === 1) { // Type 1 is Image
    
      setValue(`formRows[${index}].description`, ""); // Clear description
      
      setFormType(prev => ({ ...prev, [index]: value }));
    } else if (value === 2) { // Type 2 is Description
      if(route !== "edit"){
      setValue(`formRows[${index}].image`, null); // Clear image
    }
      setFormType(prev => ({ ...prev, [index]: value }));
    }
  };

  const getCustomStyles = (hasError) => ({
    control: (provided) => ({
      ...provided,
      borderColor: hasError ? 'red' : provided.borderColor,
      boxShadow: 'none',
      '&:hover': {
        borderColor: hasError ? 'red' : provided.borderColor,
      },
    }),
    indicatorSeparator: () => ({
      display: 'none',
    }),
  });
  const handleRemove = (index) => {
    // Log state before removal
  
    // Remove the field
    remove(index);

    setFormType(prev => {
      const newFormType = { ...prev };
      delete newFormType[index];
      // Re-index formType to keep it sequential
      return Object.keys(newFormType).reduce((acc, key) => {
        acc[parseInt(key, 10) < index ? parseInt(key, 10) : parseInt(key, 10) - 1] = newFormType[key];
        return acc;
      }, {});
    });
  
   
   
  };
  const handleSortingKeyPress = (e) => {
    if (!/[0-9]/.test(e.key)) {
      e.preventDefault();
    }
  };

  const handleSortingChange = (index, e) => {
    const value = e.target.value.replace(/[^0-9]/g, ''); // Ensure only numeric values
    setValue(`formRows[${index}].sorting`, value);
  };
  return (
    <>
      {viewModel && viewImageUrl && (
        <ViewModal
          show={viewModel}
          onCloseClick={() => setViewModel(false)}
          data={viewImageUrl}
        />
      )}

      {fields.map((field, index) => {
        const selectedType = formType[index];

        return (
          <Row key={field.id} className="mb-3">
            {/* Sorting Field */}

              <Col lg={2}>
                <CustomLabel htmlFor={`formRows[${index}].sorting`} isRequired>
                  Sorting
                </CustomLabel>
                <Controller
                  name={`formRows[${index}].sorting`}
                  control={control}
                  render={({ field }) => (
                    <Input
                      type="text"
                      {...field}
                      onKeyPress={handleSortingKeyPress} // Prevent non-numeric key presses
                      onChange={(e) => handleSortingChange(index, e)} // Ensure numeric value
                      maxlength="5"
                      invalid={!!errors.formRows?.[index]?.sorting}
                      
                      placeholder="Enter sorting order"
                      
                    />
                  )}
                />
                {errors.formRows?.[index]?.sorting && (
                  <FormFeedback>
                    {errors.formRows[index].sorting.message}
                  </FormFeedback>
                )}
              </Col>

            {/* Type Dropdown */}
            <Col lg={2}>
              <CustomLabel htmlFor={`formRows[${index}].type`} isRequired>
                Type
              </CustomLabel>
              <Controller
                name={`formRows[${index}].type`}
                control={control}
                render={({ field }) => (
                  <>
                    <Select
                      {...field}
                      options={[
                        { value: 1, label: 'Image' },
                        { value: 2, label: 'Description' }
                      ]}
                      placeholder="Select Type"
                      onChange={(selectedOption) => {
                        const typeValue = selectedOption ? selectedOption.value : null;
                        field.onChange(typeValue);
                        handleTypeChange(index, typeValue);
                      }}
                      value={
                        [{ value: 1, label: 'Image' }, { value: 2, label: 'Description' }]
                          .find(option => option.value === field.value) || null
                      }
                      isClearable
                      styles={getCustomStyles(!!errors.formRows?.[index]?.type)}
                    />
                    {errors.formRows?.[index]?.type && (
                      <FormFeedback className="d-block">
                        {errors.formRows[index].type.message}
                      </FormFeedback>
                    )}
                  </>
                )}
              />
            </Col>

            {/* Description Field */}
            {selectedType === 2 && (
              <Col lg={4}>
                <CustomLabel htmlFor={`formRows[${index}].description`} isRequired>
                  Description
                </CustomLabel>
                <Controller
                  name={`formRows[${index}].description`}
                  control={control}
                  render={({ field }) => (
                    <Input
                      type="textarea"
                      {...field}
                      invalid={!!errors.formRows?.[index]?.description}
                      placeholder="Enter Your Description"
                    />
                  )}
                />
                {errors.formRows?.[index]?.description && (
                  <FormFeedback>
                    {errors.formRows[index].description.message}
                  </FormFeedback>
                )}
              </Col>
            )}

            {/* Image Field */}
            {selectedType === 1 && (
              <Col lg={4}>
                <CustomLabel htmlFor={`formRows[${index}].image`} isRequired>
                  Image
                </CustomLabel>
                {route === "edit" && data[index]?.image?.image_url ? (
                  <button
                    type="button"
                    className="view-button"
                    onClick={() => {
                      handleViewImage(data[index].image.image_url);
                    }}
                  >
                    View
                  </button>
                ) : null}

                <Controller
                  name={`formRows[${index}].image`}
                  control={control}
                  render={({ field }) => (
                    <Input
                      type="file"
                      accept="image/jpeg,image/png"
                      onChange={(e) => {

                        field.onChange(e);
                        handleFileChange(index, e);
                        
                      }}
                      invalid={!!errors.formRows?.[index]?.image}
                    />
                  )}
                />
                {errors.formRows?.[index]?.image && (
                  <FormFeedback>
                    {errors.formRows[index].image?.message}
                  </FormFeedback>
                )}
              </Col>
            )}

            {index > 0 && (
              <Col lg={1} className="align-self-center mt-3">
                <Button
                  type="button"
                  className="btn btn-danger"
                  onClick={() => handleRemove(index)}
                >
                  Delete
                </Button>
              </Col>
            )}
          </Row>
        );
      })}
      <Button
        type="button"
        className="btn btn-info mt-3"
        onClick={() => {
          append({
            type: null,
            sorting: "",
            description: "",
            image: null
          });
          
        }}
      >
        Add
      </Button>
    </>
  );
};

export default FormRepeater;